<app-folder-continuous-record class="subpage-content"></app-folder-continuous-record>

<div #dialogFooter></div>
